module.exports = __webpack_public_path__ + "img/40.28cbc3cb.jpg";